import { Box, Button } from '@mui/material'
import styled from 'styled-components'

export const AddBtnContainer = styled(Box)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
`

export const AddBtn = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: #fff;
    text-transform: none;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.2;
    min-height: 32px;
    min-width: 0;
    padding: 4px 12px;
    border-radius: 6px;
    box-shadow: none;
    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.dark};
      box-shadow: none;
    }
  }
`
